import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import moment from "moment";
import FavouriteFeedsList from "./FavouriteFeedsList";
import {
  unifiedEnvConfig,
  envConfig,
} from "../../../../constants/api-endpoint";
import { httpGet, httpPost } from "../../../../utility/requestHelper";
import Loader from "../../../Shared/Loader";
import {
  formatDate,
  getDateFormat,
  getUniqueValuesFromList,
  groupBy,
} from "../../../../utility/common-methods";
import DateRangeFilter from "../../Filters/DateRangeFilter";
import {
  VERTICALS,
  HTTP_CODES,
  COOKIE,
  DATE_FORMATS,
  SOCIAL_PERPAGE_LIMIT,
} from "../../../../constants/app-constant";
import { REQUEST_CANCELLING_CONSTANTS } from "../../../../constants/cancel-request-constants";
import { ArrowDownIcon, MenuIcon } from "../../../Icons/icons.component";
import { getCookie } from "../../../../utility/cookieProvider";
import PrintAndOnlineFavouriteFeedList from "./PrintAndOnlineFavouriteFeedList";

export const Favourites = () => {
  const today = new Date();
  const defaultValues = {
    def_fromDate: getDateFormat(today),
    def_toDate: getDateFormat(today),
  };

  const { def_toDate, def_fromDate } = defaultValues;
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID) || null;
  const concept_email = getCookie(COOKIE.CONCEPT_USER_EMAIL) || null;
  const { V_SOCIAL, V_BLOG, V_FORUM, V_BLOGS_AND_FORUMS, V_PRINT_AND_ONLINE } =
    VERTICALS;

  const dropdownConstants = [
    {
      type: V_SOCIAL,
      name: "Social",
    },
    {
      type: V_BLOGS_AND_FORUMS,
      name: "Blogs & Forum",
    },
    {
      type: V_PRINT_AND_ONLINE,
      name: "Print and Online",
    },
  ];

  const [loader, setLoader] = useState(false);
  const [favouritesList, setFavouritesList] = useState([]);
  const [printAndOnlineList, setPrintAndOnlineList] = useState({});
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [paginationData, setPaginationData] = useState({});
  const [pageCount, setPageCount] = useState(1);
  const [feedsLoader, setFeedsLoader] = useState(false);
  const [currentActiveVerticalAccordian, setCurrentActiveVerticalAccordian] =
    useState(V_BLOG);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState(
    dropdownConstants[0]
  );
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      if (
        (selectedDropdownValue && selectedDropdownValue.type == V_SOCIAL) ||
        selectedDropdownValue.type == V_PRINT_AND_ONLINE
      ) {
        fetchFavouritesList();
      } else if (
        selectedDropdownValue &&
        selectedDropdownValue.type == V_BLOGS_AND_FORUMS
      ) {
        setFavouritesList([]);
        callBlogAndForumRequest();
      }
    }
  }, [selectedClient]);

  useEffect(() => {
    if (fromDate && toDate) {
      if (
        (selectedDropdownValue && selectedDropdownValue.type == V_SOCIAL) ||
        selectedDropdownValue.type == V_PRINT_AND_ONLINE
      ) {
        fetchFavouritesList();
      } else if (
        selectedDropdownValue &&
        selectedDropdownValue.type == V_BLOGS_AND_FORUMS
      ) {
        setFavouritesList([]);
        callBlogAndForumRequest();
      }
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      setFavouritesList([]);
      if (
        (selectedDropdownValue && selectedDropdownValue.type == V_SOCIAL) ||
        selectedDropdownValue.type == V_PRINT_AND_ONLINE
      ) {
        fetchFavouritesList();
      } else if (
        selectedDropdownValue &&
        selectedDropdownValue.type == V_BLOGS_AND_FORUMS
      ) {
        setFavouritesList([]);
        callBlogAndForumRequest();
      }
    }
  }, [selectedDropdownValue]);

  const getUrl = (page, type = V_SOCIAL) => {
    let url = `${unifiedEnvConfig.GET_FAVOURITES_LIST}?client_id=${
      selectedClient.id
    }&searchParams[from_date]=${
      fromDate ? fromDate : def_fromDate
    }&searchParams[to_date]=${
      toDate ? toDate : def_toDate
    }&page=${page}&perPage=${SOCIAL_PERPAGE_LIMIT}`;
    if (type) {
      url += `&searchParams[type]=${type}`;
    } else if (selectedDropdownValue && selectedDropdownValue.type) {
      switch (selectedDropdownValue.type) {
        case V_SOCIAL:
          url += `&searchParams[type]=${V_SOCIAL}`;
          break;
        case V_BLOGS_AND_FORUMS:
          url += `&searchParams[type]=${V_BLOG}&searchParams[type]=${V_FORUM}`;
          break;
        default:
          url += `&searchParams[type]=${V_SOCIAL}`;
          break;
      }
    }
    return url;
  };

  const socialViewMoreClick = () => {
    setPageCount(pageCount + 1);
    setFeedsLoader(true);
    fetchFavouritesList(pageCount + 1, true)
      .then(() => {
        setFeedsLoader(false);
      })
      .catch(() => setFeedsLoader(false));
  };

  const blogForumViewMoreClick = (page, type) => {
    setCurrentActiveVerticalAccordian(type);
    setFavouritesList([]);
    if (type == V_FORUM) {
      fetchForumFeeds(page);
    }
    if (type == V_BLOG) {
      fetchBlogFeeds(page);
    }
  };

  const fetchForumFeeds = (page = 1) => {
    setFeedsLoader(true);
    httpGet(getUrl(page, V_FORUM))
      .then((res) => {
        setFeedsLoader(false);
        const { data, pagination } = res.data || {};
        setFavouritesData(data, pagination, page);
      })
      .catch((error) => {
        setFeedsLoader(false);
        console.log(error);
      });
  };

  const fetchBlogFeeds = (page = 1) => {
    setFeedsLoader(true);
    httpGet(getUrl(page, V_BLOG))
      .then((res) => {
        setFeedsLoader(false);
        const { data, pagination } = res.data || {};
        setFavouritesData(data, pagination, page);
      })
      .catch((error) => {
        setFeedsLoader(false);
        console.log(error);
      });
  };

  const setFavouritesData = (feeds, pagination, page) => {
    const newDataSet = [...feeds, ...favouritesList].map((item) => {
      item["page"] = page;
      item["totalFeeds"] = pagination.total;
      return item;
    });
    setFavouritesList(
      getUniqueValuesFromList([...favouritesList, ...newDataSet], "id")
    );
  };

  const callBlogAndForumRequest = () => {
    let feeds = [];
    setLoader(true);
    Promise.allSettled([
      httpGet(getUrl(1, V_BLOG)),
      httpGet(getUrl(1, V_FORUM)),
    ])
      .then((responseData) => {
        setLoader(false);
        responseData.forEach((response) => {
          response.value.data.data = response.value.data.data.map((item) => {
            item["page"] = 1;
            item["totalFeeds"] = response.value.data.pagination.total;
            return item;
          });
          feeds = [...feeds, ...response.value.data.data];
        });
        setFavouritesList(feeds);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const fetchFavouritesList = (page = 1, showMoreClick) => {
    return new Promise((resolve, reject) => {
      if (selectedDropdownValue.type == V_PRINT_AND_ONLINE) {
        fetchPrintAndOnlineFavouriteList();
      } else {
        if (selectedClient.id) {
          !showMoreClick ? setLoader(true) : setFeedsLoader(true);
          httpGet(getUrl(page))
            .then((res) => {
              !showMoreClick ? setLoader(false) : setFeedsLoader(false);
              const { data, pagination } = res.data || {};
              setPaginationData(pagination);
              if (page != 1) {
                setFavouritesList(
                  getUniqueValuesFromList([...favouritesList, ...data], "id")
                );
              } else {
                setFavouritesList(data);
              }
              resolve();
            })
            .catch((err) => {
              !showMoreClick ? setLoader(false) : setFeedsLoader(false);
              reject();
            });
        }
      }
    });
  };

  const fetchPrintAndOnlineFavouriteList = () => {
    setLoader(true);
    let params = {
      client_id: selectedClient.id,
      media_type: VERTICALS.V_PRINT_AND_ONLINE,
      // limit: "1000",
      start_date: formatDate(fromDate, DATE_FORMATS.YYYYMMDD_slash),
      end_date: formatDate(toDate, DATE_FORMATS.YYYYMMDD_slash),
      user_id: concept_uid,
      offset: "0",
      download: "",
      email: concept_email,
      is_client_favourite: "1",
    };
    httpPost(
      `${envConfig.PRINT_NEWS_TO_ENTITY}`,
      params,
      {},
      true,
      REQUEST_CANCELLING_CONSTANTS.SEARCH_API
    )
      .then((res) => {
        const {
          data: { status, result, messsage },
        } = res || {};
        if (status === HTTP_CODES.SUCCESS && result && result.data) {
          setPrintAndOnlineList(formatPrintAndOnlineFeeds(result.data));
        }
        setLoader(false);
      })
      .catch((e) => {
        setLoader(false);
      });
  };

  const handleDateChange = (date, type) => {
    const formattedDate = moment(date).format("MM/DD/YYYY");
    if (type === "start") {
      setFromDate(formattedDate);
    } else if (type === "end") {
      setToDate(formattedDate);
    }
  };

  const onDropdownChange = (item) => {
    setSelectedDropdownValue(item);
  };

  const formatPrintAndOnlineFeeds = (feeds) => {
    try {
      let allGroupedPrintData = {};
      let allGroupedOnlineData = {};
      let allPrintData = [];
      let allOnlineData = [];
      Object.keys(feeds).map((el, index) => {
        let entry = feeds[el];
        let printData = entry["Print"];
        let onlineData = entry["Online"];
        let groupedPrintData = groupBy(printData, "headline", true);
        let groupedOnlineData = groupBy(onlineData, "article_id");
        allPrintData.push({ ...printData });
        allOnlineData.push({ ...onlineData });
        allGroupedOnlineData = {
          ...allGroupedOnlineData,
          ...groupedOnlineData,
        };
        allGroupedPrintData = {
          ...allGroupedPrintData,
          ...groupedPrintData,
        };
      });
      const data = {
        entityName: "",
        printData: allPrintData,
        onlineData: allOnlineData,
        groupedOnlineData: allGroupedOnlineData,
        groupedPrintData: allGroupedPrintData,
      };
      return data;
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div className="favFeedsTopFilter">
        <Dropdown className="dashboardDropdown verticalOptionDropdown">
          <Dropdown.Toggle variant="default">
            {selectedDropdownValue.name}
            <ArrowDownIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {dropdownConstants.map((item, idx) => (
              <Dropdown.Item
                key={idx}
                value={item.name}
                onClick={() => onDropdownChange(item)}
              >
                {item.name}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <DateRangeFilter
          key="favourites-list"
          startRange={fromDate ?? def_fromDate}
          endRange={toDate ?? def_toDate}
          handleDateChange={handleDateChange}
          minDate={selectedClient ? selectedClient.start_date : null}
          maxDate={selectedClient ? selectedClient.end_date : null}
          datePickerPlacement="bottomStart"
        />
      </div>
      {loader ? (
        <Loader />
      ) : selectedDropdownValue.type == V_PRINT_AND_ONLINE ? (
        <PrintAndOnlineFavouriteFeedList entityFeeds={printAndOnlineList} />
      ) : (
        <FavouriteFeedsList
          selectedDropdownValue={selectedDropdownValue.type}
          clientId={selectedClient.id}
          favouritesList={favouritesList}
          selectedDropdownValue={selectedDropdownValue}
          paginationData={paginationData}
          socialViewMoreClick={socialViewMoreClick}
          feedsLoader={feedsLoader}
          blogForumViewMoreClick={blogForumViewMoreClick}
          currentActiveVerticalAccordian={currentActiveVerticalAccordian}
        />
      )}
    </>
  );
};
